import {css} from 'lit';
export const styles = css`.page{height:100%;display:flex;flex-direction:column;gap:1.5rem;padding:1rem;box-sizing:border-box}@media screen and (min-width: 992px){.page{gap:2rem;padding:2rem}}`;
export default styles;
